module.exports = __webpack_public_path__ + "static/cloud-storage-tab-app-cover-4b5de9d087256b8081ead85667d8b7f8.png";